import { AccumulatorStatus } from "@/features/accumulators/types.ts";

export const accumulatorTools = {
  status: {
    toString(status: AccumulatorStatus): string {
      switch (status) {
        case "open":
          return "Идет сборка заказов";
        case "close":
          return "Сборка заказов завершена";
        case "arrived":
          return "Прибыл в город получателя";
        default:
          return "";
      }
    },
    color(
      status: AccumulatorStatus,
    ): "default" | "accent" | "success" | "warning" | "danger" {
      switch (status) {
        case "open":
          return "warning";
        case "close":
          return "accent";
        case "arrived":
          return "success";
        default:
          return "default";
      }
    },
  },
};
